import styled from "styled-components";


export const DeviceDetailsWrapper = styled.div` 
    display: flex;
    flex-direction: column;
    position: absolute;
    width: 100%;
    height: 100%;
    padding: 0px 10px;
    box-sizing: border-box;
    background: #FFFFFF;

    & .ant-tabs-nav-list {
        width: 100%;
        justify-content: space-around;
    }

    & .ant-tabs-tab {
        padding-left: 10px;
        padding-right: 10px;
        margin: 0px !important;
    }

    & .ant-tabs-content {
        height: calc(100vh - 190px);
    }

    & .ant-tabs-tabpane {
        height: 100%;
    }
`;

export const TitleBar = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 10px 0px 5px 0px;
`;

export const GoBackWrapper = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
`

export const GoBackText = styled.span`
    margin-left: 10px;
`

export const DeviceNameTitle = styled.div`
    margin-left: 20px;
    font-size: 18px;
`
